import { render, staticRenderFns } from "./CatalogChapters.vue?vue&type=template&id=3f86b469&"
import script from "./CatalogChapters.vue?vue&type=script&lang=ts&"
export * from "./CatalogChapters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports